import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  topBar: {
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    margin: '0 0 0 auto',

    '& .viboToggleDropdown .viboButton, & .menuItem': {
      padding: 0,

      '& .viboIcon': {
        color: 'var(--text-primary)',
        margin: '0',

        '& svg': {
          width: '20px',
          height: '20px',

          '@media screen and (min-width: 1441px)': {
            width: '24px',
            height: '24px',
          },
        },
      },

      '&:hover': {
        backgroundColor: 'transparent',
      },
    },

    '& .tooltipContent, & .viboMenu': {
      height: '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },

    '& .menuItem, .viboToggleDropdown': {
      margin: '0 0 0 12px!important',

      '@media screen and (min-width: 1441px)': {
        margin: '0 0 0 16px!important',
      },
    },
  },

  profileImage: {
    borderRadius: '50%',
    width: '20px',
    height: '20px',

    '@media screen and (min-width: 1441px)': {
      width: '24px',
      height: '24px',
    },
  },

  toggleShowBtn: {
    boxShadow: 'none',
    display: 'flex',

    '& .viboButton': {
      // FOR GTM TRIGERS
      '& > *': {
        pointerEvents: 'none',
      },

      '& > .prefixIcon': {
        fontSize: '20px!important',

        '@media screen and (min-width: 1441px)': {
          fontSize: '24px!important',
        },
      },
    },
  },

  notificationsMenu: {
    left: 'auto!important',
    right: '20px!important',
    top: '40px!important',
    width: '464px',
    height: 'fit-content',
    zIndex: 999,

    '@media screen and (min-width: 1441px)': {
      top: '48px!important',
      width: '536px',
    },
  },

  notificationsCount: {
    fontSize: '10px',
    lineHeight: '12px',
    fontWeight: 500,
    padding: '0 2px',
    backgroundColor: 'var(--error-light)',
    color: 'var(--clr-white)',
    borderRadius: '8px',
    position: 'absolute',
    right: '0',
    height: '11px',
    minWidth: '11px',
    textAlign: 'center',
    width: 'auto!important',
  },

  notificationsHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: '13px',
    lineHeight: '19.5px',
    fontWeight: 500,
    padding: '7px 14px',
    borderBottom: `1px solid var(--selection-iconsHover)`,
    color: 'var(--text-primary)',

    '& .viboButton': {
      padding: '0',
    },

    '@media screen and (min-width: 1441px)': {
      fontSize: '16px',
      lineHeight: '24px',
      padding: '10px 16px',
    },
  },

  themeButton: {
    margin: '0 0 0 16px',

    '&.smSize': {
      padding: 0,
    },

    '&.defaultDisplay': {
      '&, &:hover': {
        backgroundColor: 'var(--whiteToEmperor)!important',
        color: 'var(--text-secondary)!important',
      },
    },

    '&.circleShape': {
      width: '20px',
      height: '20px',

      '@media screen and (min-width: 1441px)': {
        width: '24px',
        height: '24px',
      },
    },

    '& svg': {
      fill: 'none',
    },
  },

  notificationsArea: {
    backgroundColor: 'var(--whiteToShipGray)',
    userSelect: 'none',

    '& .emptyState': {
      color: 'var(--dustGrayToSilver)',
      flexDirection: 'row',
      justifyContent: 'center',
      padding: '24px 0',

      '& .viboIcon, & .description': {
        color: 'inherit',
      },

      '& .viboIcon': {
        marginRight: '12px',

        '@media screen and (min-width: 1441px)': {
          marginRight: '16px',
        },
      },

      '@media screen and (min-width: 1441px)': {
        padding: '28px 0',
      },
    },

    '& .notification:not(:last-child)': {
      borderBottom: `1px solid var(--primaryLightToBalticSeaDark)`,
    },
  },

  notificationsFooter: {
    '& .viboButton.smSize': {
      height: '36px',
      width: '100%',

      '&:hover': {
        backgroundColor: 'var(--primaryLightToBalticSea)',
        color: 'var(--button-active)',
      },

      '@media screen and (min-width: 1441px)': {
        height: '48px',
      },
    },
  },

  scrollbar: {
    height: '100%!important',
    padding: '0 0 10px 0',

    '&.withContent': {
      maxHeight: '75vh!important',

      '@media screen and (min-width: 1441px)': {
        maxHeight: '80vh!important',
      },
    },
  },

  notification: {
    display: 'flex',
    flexDirection: 'row',
    padding: '14px',
    overflow: 'hidden',

    '&:not(.isNew)': {
      opacity: '0.7',
    },

    '&:hover': {
      backgroundColor: 'var(--primaryLightToScarpaFlow)',

      '& .time': {
        color: 'var(--clr-dustyGray)',
      },
    },

    '@media screen and (min-width: 1441px)': {
      padding: '16px',
    },
  },

  notificationImage: {
    minWidth: '60px',
    width: '60px',
    height: '60px',
    position: 'relative',

    '& .viboImage': {
      borderRadius: '50%',

      '& .gradient': {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',

        '& .viboIcon': {
          color: 'var(--text-primary)',

          '& svg': {
            width: '32px',
            height: '32px',

            '@media screen and (min-width: 1441px)': {
              width: '36px',
              height: '36px',
            },
          },
        },
      },
    },

    '@media screen and (min-width: 1441px)': {
      minWidth: '72px',
      width: '72px',
      height: '72px',
    },
  },

  notificationDescription: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: '0 12px',
    color: 'var(--text-primary)',
    fontSize: '15px',
    lineHeight: '22.5px',
    width: 'calc(100% - 90px)',
    userSelect: 'none',

    '& .eventName': {
      fontWeight: 500,
    },

    '& .eventName, & .message': {
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word',
    },

    '@media screen and (min-width: 1441px)': {
      margin: '0 16px',
      fontSize: '18px',
      lineHeight: '27px',
      width: 'calc(100% - 110px)',
    },
  },

  indicators: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: 'var(--text-hint)',

    '& .newCircle': {
      width: '14px',
      height: '14px',
      backgroundColor: 'var(--primary-main)',
      borderRadius: '50%',

      '@media screen and (min-width: 1441px)': {
        width: '16px',
        height: '16px',
      },
    },

    '& .time': {
      margin: 'auto 0 0 0',
      fontSize: '13px',
      lineHeight: '19.5px',
      whiteSpace: 'nowrap',

      '@media screen and (min-width: 1441px)': {
        fontSize: '16px',
        lineHeight: '24px',
      },
    },
  },

  notificationIcon: {
    width: '24px',
    height: '24px',
    position: 'absolute',
    backgroundColor: 'var(--whiteToShipGray)',
    right: '0',
    bottom: '0',
    borderRadius: '50%',

    '&.viboIcon': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    },

    '&.hostGuestJoinedEvent, &.accountStatusChangedToActivated': {
      color: 'var(--success-main)',
    },

    '&.hostGuestLeftEvent, &.eventLocked, &.accountStatusChangedToChargeFailed': {
      color: 'var(--error-main)',
    },

    '&.customNotification': {
      color: 'var(--primary-main)',
    },

    '&.questionAnswered': {
      color: 'var(--success-main)',
    },

    '&.lockoutDate, &.songsUpdated, &.notesUpdated': {
      color: 'var(--primary-main)',
    },

    '&.accountStatusChangedToLimited': {
      color: 'var(--warning-main)',
    },

    '& svg': {
      margin: 0,
      width: '14px',
      height: '14px',

      '@media screen and (min-width: 1441px)': {
        width: '16px',
        height: '16px',
      },
    },

    '@media screen and (min-width: 1441px)': {
      width: '28px',
      height: '28px',
    },
  },
}));

export default useStyles;
